module.exports = __webpack_public_path__ + "static/media/03.87967318.webm";